import axios, { AxiosError } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { LIST_PATH, TAX_TYPE_PATH } from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getTaxTypesService = async () => {
  try {
    const result = await instance.get(TAX_TYPE_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createTaxTypeService = async (taxType: any) => {
  try {
    const result = await instance.post(TAX_TYPE_PATH, taxType)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteTaxTypeService = async (id: any) => {
  try {
    const result = await instance.delete(TAX_TYPE_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editTaxTypeService = async (id: number, taxType: any) => {
  try {
    const result = await instance.put(TAX_TYPE_PATH + `/${id}`, taxType)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
